import React, { useEffect, useState } from 'react';
import {
  getUser,
  LocalizePropType,
  selectUser,
  withTextLocalizer,
} from 'getaway-data-layer';
import { useHistory } from 'react-router-dom';
import DepositView from './DepositView';
import { isDashboardScreen, navigateTo, showAlert } from '../../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { generateDepositPaymentLink } from 'getaway-data-layer/src/redux/store/userData/user/actions';

type Props = {
  localize: LocalizePropType;
};

const DepositContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [paymentLink, setPaymentLink] = useState<string | null>(null);

  const onSubmit = () => {
    const newWindow = window.open('', '_blank');
    dispatch(
      getUser((updatedUser) => {
        if (updatedUser?.deposit?.toPayForSepaUnlock) {
          dispatch(
            generateDepositPaymentLink(
              updatedUser?.deposit?.toPayForSepaUnlock,
              undefined,
              (paymentLink: string) => {
                if (newWindow) {
                  // Redirect the new window to the payment link
                  newWindow.location.href = paymentLink;
                }
              }
            )
          );
        } else {
          navigateTo(history, '/settings');
        }
      })
    );
  };

  const onClose = () => {
    if (isDashboardScreen()) {
      navigateTo(history, '/settings');
    } else {
      showAlert(
        '',
        localize('cancel.FirstSteps.dialog.message'),
        localize('cancel.FirstSteps.dialog.yes'),
        () => navigateTo(history, '/settings'),
        localize('cancel.FirstSteps.dialog.no'),
        () => {},
        true
      );
    }
  };

  useEffect(() => {
    setTimeout(() => {
      dispatch(
        getUser((updatedUser) => {
          if (updatedUser?.deposit?.toPayForSepaUnlock) {
            dispatch(
              generateDepositPaymentLink(
                updatedUser?.deposit?.toPayForSepaUnlock,
                undefined,
                (paymentLink: string) => {
                  setPaymentLink(paymentLink);
                }
              )
            );
          } else {
            navigateTo(history, '/settings');
          }
        })
      );
    }, 100);
  }, []);

  return (
    <DepositView
      localize={localize}
      onClose={onClose}
      onSubmit={onSubmit}
      amount={user?.deposit?.toPayForSepaUnlock}
      paymentLink={paymentLink}
    />
  );
};

export default withTextLocalizer(DepositContainer);
